import React, { useContext, useState } from "react";
import { Button, Grid, Divider, Checkbox, Modal, Box, Typography, CircularProgress, TextField } from "@mui/material";
import simem_logo from "../../assets/simem_logo.svg";
import xlsm_logo from "../../assets/xlsx.png";
import { useTranslation } from "react-i18next";
import { FileOpenOutlined, InfoOutlined, RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import GeneratorFunctionality from "../../components/generator/generator-functionality";
import { UserContext } from "../../contexts/context-layout-user";
import { format } from "date-fns";
import { exeGenerators } from "../../actions/generator";
import ModalCases from "./modal-cases";
import LimitsFunctionality from "../../components/generator/limits-functionality";
import { saveLog } from "../../actions/auditLog";
import jwt_decode from 'jwt-decode';
import { element } from "../../actions/cases";
import CaseList from "./case-list";

function GeneratorModule(props) {


  const { t } = useTranslation("global");
  const language = localStorage.getItem('i18nextLng') || 'es'
  const arrayCases = props.arrayCases;

  const { filePath, projectName, caseName, periods, selectedDate, day, fileXlsmPath, setFileXlsmPath, receles, setReceles } = useContext(UserContext);
  const [selected, setSelected] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [openMessageModal, setOpenMessageModel] = useState(false);
  const [message, setMessage] = useState(null);
  const [validateFilePath, setValidateFilePath] = useState("");
  const [filePathError, setFilePathError] = useState(false);
  const [infoXlsm, setInfoXlsm] = useState(false);
  const [functionality, setFunctionality] = useState(0);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const token = localStorage.getItem('saxToken');
  const infoUser = token ? jwt_decode(token) : null;

  const handleSelect = (option) => {
    setSelected(option);
  };

  const handleConfirmAction = () => {
    setOpenModalConfirm(true);
  }

  const handleChangeFunctionality = (value) => {
    setFunctionality(value);
  }

  const handleClick = async () => {
    setOpenModalConfirm(false);
    setLoading(true);
    const sendData = {
      origin_information: selected,
      pronBarras_folder: filePath.replace(/"/g, ''),
      route_xlms_file: selected === 1 ? fileXlsmPath.replace(/"/g, '') : "",
      name_project: projectName,
      name_initial_case: caseName,
      periods_list: periods,
      day: selected === 1 ? day : "",
      API_date: selected === 0 ? format(selectedDate, 'yyyy-MM-dd') : '',
    };

    try {
      const response = await exeGenerators(sendData);

      if (response.name === "TypeError" && response.message === "Failed to fetch") {
        setMessage(t("generator.fetchError"));
        setOpenMessageModel(true);
        setLoading(false);
        return;
      }
      const dataSave = {
        auditable_type: 'user',
        auditable_id: infoUser.id,
        description_id: 8,
        new_data: sendData,
      }
      await saveLog(dataSave);

      const dataMessage = await response.json();

      setMessage(language === 'es' ? dataMessage.mensajeEs : dataMessage.mensajeEn);

      console.log("Response dataMessage:", dataMessage);
      console.log("Response status:", response);

      if (response.status === 200) {
        setLoading(false);
        setOpenMessageModel(true);
        await element(dataMessage)
      } else {
        setLoading(false);
        setOpenMessageModel(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage(t("generator.unknownError"));
      setOpenMessageModel(true);
      setLoading(false);
    }
  }

  const handleFileChange = (event) => {
    setValidateFilePath(event.target.value);
    const file = event.target.value;
    const fileExtension = file.split('.').pop().toLowerCase();
    if (fileExtension === 'xlsm' || fileExtension === 'xlsm"') {
      setFileXlsmPath(event.target.value);
      setFilePathError(false);
    } else {
      setFilePathError(true);
      setFileXlsmPath("");
    }
  };

  const styleButton = (button) => ({
    textDecoration: functionality === button ? 'underline' : 'none',
    backgroundColor: '#551a8b',
    color: "#ffffff",
    borderRadius: "10px 10px 0px 0px",
    padding: "6px 20px"
  });

  const renderModal = (open, onClose, content) => (
    <Modal open={open} onClose={onClose} disableAutoFocus>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "60%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "white",
          boxShadow: 24,
          padding: 4,
          borderRadius: "10px",
        }}
      >
        {content}
      </Box>
    </Modal>
  );

  return (
    <>
      <Grid item xs={3}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center" style={{ margin: "5px 0px 0px" }}>
          <Button
            onClick={() => {
              handleChangeFunctionality(1)
              setReceles(false);
            }}
            style={styleButton(1)}>
            {t("board.limitesButton")}
          </Button>
          <Button
            onClick={() => {
              handleChangeFunctionality(0)
              setReceles(true);
            }} style={styleButton(0)}>
            {t("board.recelesButton")}
          </Button>
        </Grid>
        <Grid container spacing={0} style={{ display: 'flex' }}>
          <Grid item style={{ flex: 1 }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
              {functionality === 0 ?
                <>
                  <Grid item xs={12} style={{ padding: "10px 0", background: "#ccc", borderRight: '1px solid rgba(0, 0, 0, 0.12)' }}>
                    <b>{t("board.recelesTitle")}</b>
                  </Grid>
                  <Grid item xs={12} style={{ borderRight: '1px solid rgba(0, 0, 0, 0.12)' }}>
                    <Grid container spacing={0}>
                      <Grid item xs={10} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: "20px 0" }}>
                        <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                          <img
                            src={xlsm_logo}
                            alt="Placeholder"
                            style={{ maxWidth: "50%", height: "auto" }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={2} style={{ padding: "10px", borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: "20px 0" }}>
                        <Grid container direction="column" spacing={2}>
                          <Grid item>
                            <Checkbox
                              icon={<RadioButtonUnchecked />}
                              checkedIcon={<RadioButtonChecked />}
                              checked={selected === 1}
                              onChange={() => handleSelect(1)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={10}>
                        <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%', padding: "20px 0" }}>
                          <img
                            src={simem_logo}
                            alt="Placeholder"
                            style={{ maxWidth: "50%", height: "auto" }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={2} style={{ padding: "10px", padding: "20px 0" }}>
                        <Grid container direction="column" spacing={2}>
                          <Grid item>
                            <Checkbox
                              icon={<RadioButtonUnchecked />}
                              checkedIcon={<RadioButtonChecked />}
                              checked={selected === 0}
                              onChange={() => handleSelect(0)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider />
                  </Grid>
                </> :
                <>
                  <Grid item xs={12} style={{ padding: "10px 0", background: "#ccc", borderRight: '1px solid rgba(0, 0, 0, 0.12)' }}>
                    <b>{t("board.limitesTitle")}</b>
                  </Grid>
                  <Grid item xs={12} style={{ borderRight: '1px solid rgba(0, 0, 0, 0.12)' }}>
                    <Grid container spacing={0}>
                      <Grid item xs={8} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: "20px 0" }}>
                        {t("board.studyCases")}
                        <ModalCases
                          open={open}
                          onOpen={handleClickOpen}
                          onClose={handleClose}
                          arrayCases={arrayCases}
                          filteredCases={props.filteredCases}
                          setFilteredCases={props.setFilteredCases}
                          setFilteredCasesMenu={props.setFilteredCasesMenu}
                          functionality={functionality}
                        />
                      </Grid>
                    </Grid>
                    <CaseList
                      filteredCases={props.filteredCases}
                      setFilteredCases={props.setFilteredCases}
                      filteredLayers={props.filteredLayers}
                      setFilteredLayers={props.setFilteredLayers}
                    />
                  </Grid>
                </>
              }
            </Grid>
            {selected !== null && receles &&
              <GeneratorFunctionality source={selected} />
            }
          </Grid>
        </Grid>
      </Grid>
      {functionality === 0 ? (
        <Grid item xs={9} id="generatorActions" style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 100px)", justifyContent: "center", alignItems: "center" }}>
          <>
            {selected === 1 &&
              <Grid
                container
                item xs={8}
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                  border: "2px dashed rgb(0, 0, 0)",
                  padding: "20px",
                  textAlign: "center",
                  borderRadius: "30px",
                  fontSize: "15px",
                }}
              >
                <FileOpenOutlined style={{ fontSize: "30px" }} />
                <TextField
                  id="filePathInput"
                  type="text"
                  value={validateFilePath}
                  onChange={handleFileChange}
                  label={t('generator.xlsm.routeFile')}
                  error={filePathError}
                  helperText={filePathError ? t('generator.xlsm.errorFile') : !filePathError && validateFilePath !== '' ? t('generator.xlsm.correctFile') : ''}
                  required
                  style={{ width: "90%", marginTop: "40px" }}
                />
                <InfoOutlined
                  style={{ cursor: "pointer", fontSize: "30px", marginTop: "40px" }}
                  onMouseEnter={() => setInfoXlsm(true)}
                />
              </Grid>
            }
            <Button
              style={{
                backgroundColor: filePath === "" || projectName === "" || caseName === "" || periods.length === 0 || (selected === 0 && selectedDate === null) || (selected === 1 && day === "") || (selected === 1 && fileXlsmPath === "") ? "#A9A9A9" : "#551A8B",
                color: "#ffffff",
                marginTop: 10,
                fontSize: "28px",
                borderRadius: "15px",
                padding: "10px 50px",
                opacity: filePath === "" || projectName === "" || caseName === "" || periods.length === 0 || (selected === 0 && selectedDate === null) || (selected === 1 && day === "") || (selected === 1 && fileXlsmPath === "") || loading ? 0.5 : 1
              }}
              variant="contained"
              onClick={handleConfirmAction}
              disabled={filePath === "" || projectName === "" || caseName === "" || periods.length === 0 || (selected === 0 && selectedDate === null) || (selected === 1 && day === "") || (selected === 1 && fileXlsmPath === "") || loading}
            >
              {loading && <CircularProgress color="inherit" style={{ marginRight: 15, fontSize: 15 }} />}
              {t("board.execute")}
            </Button>
            {loading &&
              <Typography variant="h6" gutterBottom style={{ marginTop: 20 }}>
                {t("generator.wait")}
              </Typography>
            }
            <InfoOutlined
              style={{ cursor: "pointer", fontSize: "30px", marginTop: 50 }}
              onMouseEnter={() => setOpenModal(true)}
            />

            {renderModal(openModalConfirm, () => setOpenModalConfirm(false), (
              <>
                <Typography variant="h6" gutterBottom>
                  {t('generator.confirmation')}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => setOpenModalConfirm(false)}
                  style={{
                    border: "1px solid #551a8b",
                    color: "#551a8b"
                  }}
                >
                  {t('generator.cancel')}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClick}
                  style={{
                    backgroundColor: "#551a8b", marginLeft: "20px"
                  }}>
                  {t('generator.accept')}
                </Button>
              </>
            ))}

            {renderModal(openMessageModal, () => setOpenMessageModel(false), (
              <>
                <Typography variant="h6" gutterBottom>
                  {message}
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => setOpenMessageModel(false)}
                  style={{ backgroundColor: "#551a8b" }}>
                  {t('generator.accept')}
                </Button>
              </>
            ))}

            <Modal
              open={infoXlsm}
              onClose={() => setInfoXlsm(false)}
              disableAutoFocus
            >
              <Box
                onMouseEnter={() => setInfoXlsm(true)}
                onMouseLeave={() => setInfoXlsm(false)}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "60%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "white",
                  boxShadow: 24,
                  padding: 4,
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  {t('generator.xlsm.description')}
                </Typography>
                <Typography>
                  <a href="https://www.xm.com.co/corto-plazo/mantenimientos-semanal/coordinacion-de-mantenimientos-recomendaciones-electricas"
                    target="_blank"
                    rel="noopener noreferrer">
                    {t('generator.xlsm.link')}
                  </a>
                </Typography>
              </Box>
            </Modal>

            <Modal
              open={openModal}
              onClose={() => setOpenModal(false)}
              disableAutoFocus
            >
              <Box
                onMouseEnter={() => setOpenModal(true)}
                onMouseLeave={() => setOpenModal(false)}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "60%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "white",
                  boxShadow: 24,
                  padding: 4,
                  borderRadius: "10px",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  {t('generator.infoButton')}
                </Typography>
              </Box>
            </Modal>
          </>
        </Grid>
      ) :
        <Grid item xs={9} style={{ paddingLeft: "2%", paddingTop: "3%", justifyContent: "flex-start", alignItems: "flex-start" }}>
          <LimitsFunctionality {...props} />
        </Grid>
      }
    </>
  );
}

export default GeneratorModule;
